import cn from 'clsx'

import { ImageBox, NavLink, Copy } from 'shared-components'

import BlockArrow from '../../images/blockArrow'

import s from './Project.module.sass'

function Project({ project }: any) {
    const { title, slug, featuredImage, projectCategories, location, summary } = project

    const _projectCategories = projectCategories
        ? projectCategories.map((category: any) => category?.name).join(', ')
        : null

    return (
        <div className={s.Project}>
            <NavLink href={`/our-work/${slug}`} className={s.Link}>
                <div className={cn(s.Cont, 'container')}>
                    <div className={s.Image}>{featuredImage && <ImageBox image={featuredImage} width={900} height={900} />}</div>
                    <div className={s.Content}>
                        <h3>{title}</h3>
                        <div className={s.ProjectDetails}>
                            {_projectCategories && (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: _projectCategories,
                                    }}
                                />
                            )}
                            {location && <span dangerouslySetInnerHTML={{ __html: location }} />}
                            {summary && (
                                <div className={s.Summary}>
                                    <Copy copy={summary} />
                                </div>
                            )}
                        </div>
                        {BlockArrow}
                    </div>
                </div>
            </NavLink>
        </div>
    )
}

export default Project
